export function classifySessionError(error: unknown): "error" | "credits-exhausted" {
  if (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    (error as { name?: unknown }).name === "InsufficientCreditsError"
  ) {
    return "credits-exhausted"
  }
  return "error"
}
